<!--
  vivest-modal (design system): título no atributo heading; busca e lista no slot "description"
  (o modal não tem slot de conteúdo livre); botões no slot "actions". Esc fecha (dismissible) e o
  fechamento nativo do <dialog> dispara vivest-close.
-->
<vivest-modal
  heading="Adicionar documentos"
  [hasIcon]="false"
  open
  dismissible
  (vivest-close)="onFechar()"
  data-testid="resgate-documentos-modal"
>
  <div slot="description" class="resgate-documentos-modal">
    <p class="resgate-documentos-modal__descricao">
      Os documentos escolhidos entram na lista como obrigatórios.
    </p>

    <label class="visually-hidden" for="resgate-documentos-busca">Buscar documento</label>
    <input
      #campoBusca
      id="resgate-documentos-busca"
      type="search"
      class="form-control campanha-form-control"
      placeholder="Buscar documento"
      autocomplete="off"
      [value]="busca()"
      (input)="aoBuscar($any($event.target).value)"
      data-testid="resgate-documentos-busca"
    />

    <div class="resgate-documentos-modal__lista">
      @if (carregando()) {
        <p class="resgate-documentos-modal__aviso" data-testid="resgate-documentos-carregando">
          Carregando documentos…
        </p>
      } @else {
        <ul class="resgate-documentos-modal__itens">
          @for (opcao of opcoesFiltradas(); track opcao.id) {
            <li
              class="resgate-documentos-modal__item"
              [class.resgate-documentos-modal__item--incluido]="jaIncluido(opcao)"
            >
              <vivest-checkbox
                class="resgate-documentos-modal__opcao"
                label-variant="multi-line"
                name="documentos-disponiveis"
                [value]="opcao.nome"
                [checked]="jaIncluido(opcao) || estaSelecionado(opcao)"
                [disabled]="jaIncluido(opcao)"
                (change)="alternar(opcao)"
                [attr.data-testid]="'resgate-documento-opcao-' + opcao.id"
              >
                {{ opcao.nome }}
              </vivest-checkbox>
              @if (jaIncluido(opcao)) {
                <span class="resgate-documentos-modal__tag">Já incluído</span>
              }
            </li>
          } @empty {
            <li class="resgate-documentos-modal__aviso" data-testid="resgate-documentos-vazio">
              Nenhum documento encontrado para essa busca.
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <vivest-button
    slot="actions"
    variant="outline"
    size="md"
    data-testid="resgate-documentos-cancelar"
    (click)="onFechar()"
  >
    Cancelar
  </vivest-button>
  <vivest-button
    slot="actions"
    variant="primary"
    size="md"
    [disabled]="totalSelecionado() === 0"
    data-testid="resgate-documentos-adicionar"
    (click)="confirmar()"
  >
    {{ totalSelecionado() > 0 ? 'Adicionar (' + totalSelecionado() + ')' : 'Adicionar' }}
  </vivest-button>
</vivest-modal>
